import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  Body,
  Children,
  MainHolder,
  CurveHolder,
} from "../../../components/common/basic";
import { Box, StyledText, BackButton } from "../../../components/common";
import BoxSwitch from "./components/boxSwitch";
import styled from "styled-components";
import { Curve, DataIcon, GiftIcon } from "../../../components/svgs";

import ReferralStatusCard from "./components/referralStatusCard";
import { formatDate } from "../../../services/utils";


const MyReferralsScreen = () => {
  const history = useHistory();
  const { state } = useLocation();
  const { referrals, pointsData = [] } = state || {};
  const [completedReferrals, setCompletedReferrals] = useState([]);
  const [isOn, toggleSwitchState] = useState(true);

  useEffect(() => {
    if (referrals) {
      setCompletedReferrals(referrals)
    }
  }, [referrals]);

  return (
    <>
      <MainHolder style={{ background: "#F2F2F2" }}>
        <Children>
          <Header background={"#E31C79"}>
            <BackButton
              onClick={() => {
                history.goBack();
              }}
            />
            <div style={{ height: 65 }}></div>
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
              <StyledText
                style={{ fontFamily: "MTNRegular" }}
                size={24}
                margin="0"
                color="white"
              >
                Referrals
              </StyledText>
            </div>
            <BoxSwitch
              onLabel={"Completed"}
              offLabel={"Points gained"}
              background={"#E31C79"}
              isOn={isOn}
              onToggle={toggleSwitchState}
            />
          </Header>
          <CurveHolder style={{ zIndex: 1, position: "relative" }}>
            <Curve fill={"#F2F2F2"} />
          </CurveHolder>

          <Body>{isOn ?
            <CompletedReferrals data={completedReferrals} /> :
            <ReferralPoints data={pointsData} />}</Body>
        </Children>
      </MainHolder>
    </>
  );
};

export default MyReferralsScreen;

const Header = styled.div`
  overflow: hidden;
  padding: 20px 20px 80px 20px;
  background-color: ${({ background }) => background};
  position: relative;
  background-size: cover;
`;

const ReferralPoints = ({ data }) => {
  return (
    <Box
      style={{
        display: "flex",
        backgroundColor: "transparent",
        marginTop: -35,
        flexDirection: "column",
      }}
    >
      <DataContainer>
        <div>
          <StyledText
            style={{
              margin: 0,
              textAlign: 'center',
              fontFamily: "MTNRegular",
              fontSize: 14,
              color: "#7F7F7F",
            }}
          >
            {`Refer friends and loved ones to earn prizes`}
          </StyledText>
        </div>
      </DataContainer>
      {data?.length > 0 ? (
        <>
          {data.map((pointsEarned) =>
          (
            <ReferralStatusCard
              contact={`You gained ${Math.round(pointsEarned?.points)} points`}
              status={"Completed"}
              date={pointsEarned?.expiryDate
                ? `Expires ${formatDate(pointsEarned?.expiryDate)}` : ''}
              cardStatus="Completed"
              hideStatusText={true}
              datePreText=""
            />
          )
          )}
        </>
      ) : (
        <NoCompletedReferralPendingView />
      )}
    </Box>
  );
};

const CompletedReferrals = ({ data }) => {
  const maxReferralCountForData = 3;
  const numCompletedCapped = data?.length <= maxReferralCountForData
    ? data.length : maxReferralCountForData;

  const dataReceived = (a) => {
    if (a < 3) return 0;
    return a * 350;
  };

  return (
    <Box
      style={{
        display: "flex",
        backgroundColor: "transparent",
        marginTop: -35,
        flexDirection: "column",
      }}
    >
      <DataContainer>
        <DataIcon
          fill="#C8CBCB"
          style={{
            border: "1px solid #C8CBCB",
            padding: 10,
            borderRadius: 10,
            marginRight: 15,
          }}
        />
        {numCompletedCapped > 0 ? (
          <div>
            <StyledText style={{ margin: 0, marginBottom: 5 }}>
              Data Received: {dataReceived(numCompletedCapped)}MB
            </StyledText>

            <StyledText style={{ margin: 0, fontFamily: "MTNRegular", fontSize: 13 }}>
              {numCompletedCapped === 3
                ? 'Refer to build points'
                : `${3 - numCompletedCapped} more referral${3 - numCompletedCapped > 1 ? 's' : ''} to earn 1050MB`}
            </StyledText>
          </div>
        ) : (
          <div>
            <StyledText style={{ margin: 0, marginBottom: 5 }}>
              No data received yet
            </StyledText>

            <StyledText
              style={{
                margin: 0,
                fontFamily: "MTNRegular",
                fontSize: 12,
                color: "#7F7F7F",
              }}
            >
              Complete 3 referrals to earn 1050 MB
            </StyledText>
          </div>
        )}
      </DataContainer>
      {numCompletedCapped > 0 ? (
        <>
          {data.map((referral) =>
          (
            <ReferralStatusCard
              contact={referral.phonenumber}
              status={"Completed"}
              date={formatDate(referral.createdAt)}
              cardStatus="Completed"
            />
          )
          )}
        </>
      ) : (
        <NoCompletedReferralCompletedView />
      )}
    </Box>
  );
};

const NoCompletedReferralPendingView = () => {
  return (
    <NoCompletedReferralContainer>
      <GiftIcon fill="#7F7F7F" width={100} />
      <StyledText style={{ fontFamily: "MTNRegular", color: "#7F7F7F" }}>
        You haven't gained any points yet
      </StyledText>
    </NoCompletedReferralContainer>
  );
};
const NoCompletedReferralCompletedView = () => {
  return (
    <NoCompletedReferralContainer>
      <GiftIcon fill="#7F7F7F" width={100} />
      <StyledText style={{ fontFamily: "MTNRegular", color: "#7F7F7F" }}>
        You have no completed referrals
      </StyledText>
    </NoCompletedReferralContainer>
  );
};

const DataContainer = styled.div`
  display: flex;
  align-items: center;
  width: 90%;
  height: 10%;
  border: 2px solid #e31c79;
  padding: 15px;
  background-color: white;
  border-radius: 10px;
  z-index: 10;
  margin-top: -60px;
  margin-bottom: 20px;
`;
const NoCompletedReferralContainer = styled.div`
  height: 50vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 35%;
`;
